import React from 'react';

import {
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';

import type { ChildApplyJson } from '@/types/domain/childApply/entities/childApplyEntity';

import CustomListItem from '@/components/CustomListItem';
import { ChildApplyEntity } from '@/domain/childApply/service/entity/childApplyEntity';
import { Address } from '@/domain/childApply/service/entity/valueObjects/address';
import { ApplyDateTime } from '@/domain/childApply/service/entity/valueObjects/applyDateTime';
import { ApplyStatus } from '@/domain/childApply/service/entity/valueObjects/applyStatus';
import { Birthday } from '@/domain/childApply/service/entity/valueObjects/birthday';
import { ChildId } from '@/domain/childApply/service/entity/valueObjects/childId';
import { Email } from '@/domain/childApply/service/entity/valueObjects/email';
import { FacilityName } from '@/domain/childApply/service/entity/valueObjects/facilityName';
import { Gender } from '@/domain/childApply/service/entity/valueObjects/gender';
import { ParentId } from '@/domain/childApply/service/entity/valueObjects/parentId';
import { PostalCode } from '@/domain/childApply/service/entity/valueObjects/postalCode';
import { Tel } from '@/domain/childApply/service/entity/valueObjects/tel';
import { toStringDateDisplay, toStringDateTimeDisplay } from '@/utils/date';

const ChildApplyInfo: React.FC<{
  /** データ */
  data: ChildApplyJson,
}> = ({ data }) => {
  const {
    facilityName,
    applyDateTime,
    childFamilyName,
    childFamilyNameKana,
    childName,
    childNameKana,
    gender,
    birthday,
    childId,
    parentFamilyName,
    parentFamilyNameKana,
    parentName,
    parentNameKana,
    parentId,
    email,
    tel,
    postalCode,
    address,
  } = data.data;
  return (
    <>
      <List>
        <CustomListItem
          name={ApplyStatus.label}
          content={data.pub?.data.applyStatus || '-'}
        />
      </List>
      <Divider />
      <List>
        <ListItem>
          <ListItemText primary={ChildApplyEntity.labelApplyInfo} />
        </ListItem>
        <CustomListItem name={FacilityName.label} content={facilityName} />
        <CustomListItem
          name={ApplyDateTime.label}
          content={toStringDateTimeDisplay(new Date(applyDateTime))}
        />
      </List>
      <Divider />
      <List>
        <ListItem>
          <ListItemText primary={ChildApplyEntity.labelChildInfo} />
        </ListItem>
        <CustomListItem name={ChildApplyEntity.labelName} content={`${childFamilyName} ${childName}`} />
        <CustomListItem name={ChildApplyEntity.labelNameKana} content={`${childFamilyNameKana} ${childNameKana}`} />
        <CustomListItem name={Gender.label} content={gender} />
        <CustomListItem
          name={Birthday.label}
          content={toStringDateDisplay(new Date(birthday), false)}
        />
        <CustomListItem name={ChildId.label} content={childId} />
      </List>
      <Divider />
      <List>
        <ListItem>
          <ListItemText primary={ChildApplyEntity.labelParentInfo} />
        </ListItem>
        <CustomListItem name={ChildApplyEntity.labelName} content={`${parentFamilyName} ${parentName}`} />
        <CustomListItem name={ChildApplyEntity.labelNameKana} content={`${parentFamilyNameKana} ${parentNameKana}`} />
        <CustomListItem name={Email.label} content={email} />
        <CustomListItem name={PostalCode.label} content={postalCode} />
        <CustomListItem name={Address.label} content={address} />
        <CustomListItem name={Tel.label} content={tel} />
        <CustomListItem name={ParentId.label} content={parentId} />
      </List>
    </>
  );
};

export default ChildApplyInfo;
